__turbopack_context__.v({
  "badgeGrid": "HGLl7W_badgeGrid",
  "changeItemCard": "HGLl7W_changeItemCard",
  "changeModeButtons": "HGLl7W_changeModeButtons",
  "detailIntro": "HGLl7W_detailIntro",
  "detailIntro__muted": "HGLl7W_detailIntro__muted",
  "detailIntro__separator": "HGLl7W_detailIntro__separator",
  "detailIntro__title": "HGLl7W_detailIntro__title",
  "detailView": "HGLl7W_detailView",
  "footer": "HGLl7W_footer",
  "footer__actions": "HGLl7W_footer__actions",
  "formGrid": "HGLl7W_formGrid",
  "itemSummary": "HGLl7W_itemSummary",
  "itemSummaryList": "HGLl7W_itemSummaryList",
  "itemSummary__impact": "HGLl7W_itemSummary__impact",
  "itemSummary__row": "HGLl7W_itemSummary__row",
  "itemSummary__title": "HGLl7W_itemSummary__title",
  "serviceTypeActions": "HGLl7W_serviceTypeActions",
  "serviceTypeEditor": "HGLl7W_serviceTypeEditor",
  "serviceTypeName": "HGLl7W_serviceTypeName",
  "serviceTypeRow": "HGLl7W_serviceTypeRow",
  "serviceTypeRows": "HGLl7W_serviceTypeRows",
  "stepBody": "HGLl7W_stepBody",
  "stepDescription": "HGLl7W_stepDescription",
  "stepTitle": "HGLl7W_stepTitle",
  "twoColumnGrid": "HGLl7W_twoColumnGrid",
  "wizard": "HGLl7W_wizard",
});
